<lib-modal
  [title]="'Parts of the e-service lack translations'"
  [showPrimaryButton]="true"
  [showCloseButton]="true"
  [primaryButtonText]="'Ok'"
  (primaryButton)="modalRef.hide()"
  (closeModal)="modalRef.hide()"
>
  <p>
    Unfortunately, not all of our e-services are in English yet, but work is in
    progress and we hope to be able to offer the entire service in English soon.
  </p>
</lib-modal>
